module.exports = __webpack_public_path__ + "media/images/riders/small/LUCA_SHAW-abd3ba469d5333ac4b03f80becff38ac.png";